import { render, staticRenderFns } from "./MatchScoreLabel.vue?vue&type=template&id=34eef48a&"
import script from "./MatchScoreLabel.vue?vue&type=script&lang=js&"
export * from "./MatchScoreLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports